export default {
  titulos: {
    listagem: 'Imagens de Serviços',
    novo: 'Nova Imagem de Serviço',
    editar: 'Editar Imagem de Serviço',
  },
  cadastro_sucesso: 'Imagem associada ao serviço com sucesso!',
  exclusao_sucesso: 'Imagem desassociada com sucesso!',
  tabela: {
    nome: 'Nome',
  },
  formulario: {
    nome: 'Nome',
    imagem: 'Imagem',
  },
  erros: {
    id_invalido: 'O id da imagem é inválido',
    selecione_servico: 'Selecione um ou mais serviços',
  },
  filtro: {
    nome: 'Nome',
  },
  validacoes: {
    formulario_invalido: 'Formulário inválido',
  },
}